import { Paper, Grid } from '@mui/material';
import { AircraftTechSpecsReport, AssetInfoLogReport, AccountsReceivableReport, PaymentsReceivedReport, EngineTechSpecsReport, FleetInformationReport, EngineLLPLimiterReport, EngineCustomTechnicalReport, FleetSummaryValuationsReport, MRFundBalanceReport, DeconsolidateInvoicesReport, InsuranceOverviewReport, ContractExpiryReport, PortfolioReport ,MonthlyRevenueReport, EngineFleetReport, OpsReport } from '../components';
import "../../assets/styles/_fleet_report.scss"
import { useEffect, useState } from 'react';
import { trackActivity } from '../../../utils/mixpanel';
import { getAircraftTypeList, getApuTypeList, getAssetApi, getEngineTypeList, getLeaseCountriesApi, getLesseeApi, getLessorApi, getReportConstantsApi } from '../apiService';
import { globalGetService, globalPostService } from '../../../utils/globalApiServices';
import { checkApiStatus } from '../../../utils';
import { gaTelesisInstance, hanwahaInstance, titanAviationIntance } from '../../../shared_elements';
import DeploymentBannerWithOffset from '../../../shared_elements/components/DeploymentBannerWithOffSet';

const initialPltConstants = {
    lessor: [],
    lessee: [],
    asset: [],
    aircraft_types: [],
    engine_types: [],
    apu_types: [],
    lease_status: [],
    invoice_type: [],
    country: [],
    countries: [],
};

const initialDropDownLoader = {
    lessor: false,
    lessee: false,
    asset: false,
    aircraft_types: false,
    engine_types: false,
    apu_types: false,
    lease_status: false,
    invoice_type: false,
    country: false,
};

const Reports = () => {
    const [pltConstants, setPltConstants] = useState(initialPltConstants);
    const [dropDownLoader, setDropDownLoader] = useState(initialDropDownLoader);

    const getLessorAc = () => {
        setDropDownLoader(prev => ({ ...prev, lessor: true }))
        globalGetService(getLessorApi())
            .then(response => {
                if (checkApiStatus(response)) {
                    setDropDownLoader(prev => ({ ...prev, lessor: false }))
                    setPltConstants(prevConstants => ({
                        ...prevConstants,
                        lessor: response?.data?.data || []
                    }));
                }
            })
    }
    const getLesseeAc = () => {
        setDropDownLoader(prev => ({ ...prev, lessee: true }))
        globalGetService(getLesseeApi())
            .then(response => {
                if (checkApiStatus(response)) {
                    setDropDownLoader(prev => ({ ...prev, lessee: false }))
                    setPltConstants(prevConstants => ({
                        ...prevConstants,
                        lessee: response?.data?.data || []
                    }));
                }
            })
    }
    const getAssetAc = () => {
        setDropDownLoader(prev => ({ ...prev, asset: true }))
        globalGetService(getAssetApi())
            .then(response => {
                if (checkApiStatus(response)) {
                    setDropDownLoader(prev => ({ ...prev, asset: false }))
                    setPltConstants(prevConstants => ({
                        ...prevConstants,
                        asset: response?.data?.data || []
                    }));
                }
            })
    }

    const getAircraftTypeAc = () => {
        setDropDownLoader((prev) => ({ ...prev, aircraft_types: true }));
        globalGetService(getAircraftTypeList())
            .then((response) => {
                if (checkApiStatus(response)) {
                    setPltConstants((prevConstants) => ({
                        ...prevConstants,
                        aircraft_types: response?.data?.data || [],
                    }));
                }
                setDropDownLoader((prev) => ({ ...prev, aircraft_types: false }));
            })
    };

    const getEngineTypeAc = () => {
        setDropDownLoader((prev) => ({ ...prev, engine_types: true }));
        globalGetService(getEngineTypeList())
            .then((response) => {
                if (checkApiStatus(response)) {
                    setPltConstants((prevConstants) => ({
                        ...prevConstants,
                        engine_types: response?.data?.data?.engineTypes || [],
                    }));
                }
                setDropDownLoader((prev) => ({ ...prev, engine_types: false }));
            })
    };

    const getApuTypeAc = () => {
        setDropDownLoader((prev) => ({ ...prev, apu_types: true }));
        globalGetService(getApuTypeList())
            .then((response) => {
                if (checkApiStatus(response)) {
                    setPltConstants((prevConstants) => ({
                        ...prevConstants,
                        apu_types: response?.data?.data || [],
                    }));
                }
                setDropDownLoader((prev) => ({ ...prev, apu_types: false }));
            })
    };

    const getConstantsAc = () => {
        setDropDownLoader((prev) => ({ ...prev, lease_status: true, invoice_type: true }));
        globalPostService(getReportConstantsApi(), { constant_types: ['lease_status', 'invoice_type'] })
            .then((response) => {
                if (checkApiStatus(response)) {
                    const constants = response?.data?.data || {};
                    setPltConstants((prevConstants) => ({
                        ...prevConstants,
                        lease_status: constants.filter(option=>option?.type==='lease_status') || [],
                        invoice_type: constants.filter(option=>option?.type==='invoice_type') || [],
                    }));
                }
                setDropDownLoader((prev) => ({ ...prev, lease_status: false, invoice_type: false }));
            })
    };

    const getCountryAc = () => {
        setDropDownLoader((prev) => ({ ...prev, country: true }));
        globalGetService(getLeaseCountriesApi())
            .then((response) => {
                if (checkApiStatus(response)) {
                    const countries = response?.data?.data || [];
                    setPltConstants((prevConstants) => ({
                        ...prevConstants,
                        countries: countries,
                    }));
                }
                setDropDownLoader((prev) => ({ ...prev, country: false }));
            })
    };
    useEffect(() => {
        trackActivity('Page Viewed', { page_title: 'Reports' })
        getLessorAc(); getLesseeAc(); getAssetAc();
        if (gaTelesisInstance) {
            getAircraftTypeAc();
            getEngineTypeAc();
            getApuTypeAc();
            getConstantsAc();
            getCountryAc();
        }
    }, []);
    return (
        <>
        <DeploymentBannerWithOffset>
            {(bannerHeight) => (
        <Paper elevation={0} className='custom-reports lease-module-paper' style={{ '--banner-height': `${bannerHeight}px` }}>
            <Grid className="custom-reports-grid" container spacing={1.5}>
                <Grid size={{ xs: 12, sm: 6 }}><AircraftTechSpecsReport pltConstants={pltConstants} dropDownLoader={dropDownLoader} /></Grid>
                <Grid size={{ xs: 12, sm: 6 }}><EngineLLPLimiterReport pltConstants={pltConstants} dropDownLoader={dropDownLoader} /></Grid>
                <Grid size={{ xs: 12, sm: 6 }}><AccountsReceivableReport pltConstants={pltConstants} dropDownLoader={dropDownLoader} /></Grid>
                <Grid size={{ xs: 12, sm: 6 }}><PaymentsReceivedReport pltConstants={pltConstants} dropDownLoader={dropDownLoader} /></Grid>
                <Grid size={{ xs: 12, sm: 6 }}><EngineTechSpecsReport pltConstants={pltConstants} dropDownLoader={dropDownLoader} /></Grid>
                <Grid size={{ xs: 12, sm: 6 }}><FleetInformationReport pltConstants={pltConstants} dropDownLoader={dropDownLoader} /></Grid>
                <Grid size={{ xs: 12, sm: 6 }}><EngineCustomTechnicalReport pltConstants={pltConstants} dropDownLoader={dropDownLoader} /></Grid>
                <Grid size={{ xs: 12, sm: 6 }}><FleetSummaryValuationsReport pltConstants={pltConstants} dropDownLoader={dropDownLoader} /></Grid>
                <Grid size={{ xs: 12, sm: 6 }}><AssetInfoLogReport pltConstants={pltConstants} dropDownLoader={dropDownLoader} /></Grid>
                <Grid size={{ xs: 12, sm: 6 }}><ContractExpiryReport /></Grid>
                <Grid size={{ xs: 12, sm: 6 }}><MRFundBalanceReport pltConstants={pltConstants} dropDownLoader={dropDownLoader} /></Grid>
                <Grid size={{ xs: 12, sm: 6 }}><DeconsolidateInvoicesReport pltConstants={pltConstants} dropDownLoader={dropDownLoader} /></Grid>
                {hanwahaInstance && (
                    <Grid size={{ xs: 12, sm: 6 }}><MonthlyRevenueReport pltConstants={pltConstants} dropDownLoader={dropDownLoader} /></Grid>
                )}
                  {hanwahaInstance && (
                    <Grid size={{ xs: 12, sm: 6 }}><EngineFleetReport pltConstants={pltConstants} dropDownLoader={dropDownLoader} /></Grid>
                )}
                <Grid size={{ xs: 12, sm: 6 }}><InsuranceOverviewReport pltConstants={pltConstants} dropDownLoader={dropDownLoader} /></Grid>
                {titanAviationIntance && <Grid size={{ xs: 12, sm: 6 }}><PortfolioReport pltConstants={pltConstants} dropDownLoader={dropDownLoader} /></Grid>}
                {titanAviationIntance && <Grid size={{ xs: 12, sm: 6 }}><OpsReport pltConstants={pltConstants} dropDownLoader={dropDownLoader} /></Grid>}
            </Grid>
        </Paper>
        )}
        </DeploymentBannerWithOffset>
        </>
    )
}
// export default RoleBaseAccess(CustomReports, { application: 'lease_revamp', feature: 'utilization', operationType: ['R'] });
export default Reports
